import facebook from "../img/facebook.svg";
import twitter from "../img/twitter.svg";
import instagram from "../img/instagram.svg";
import linkedin from "../img/linkedin.svg";

const socialData = () => {
  return [
    {
      title: "Facebook",
      img: facebook,
      index: 0,
    },

    {
      title: "Twitter",
      img: twitter,
      index: 1,
    },

    {
      title: "Instagram",
      img: instagram,
      index: 2,
    },

    {
      title: "LinkedIn",
      img: linkedin,
      index: 3,
    },
  ];
};

export default socialData;
